import { axiosInstance } from '../Middleware'
import { ResponseGetAllType } from '../response'
import { Bulletin } from './types'

export class BulletinApi {
  public static loadBulletin = (complement?: string, silent?: boolean) : Promise<ResponseGetAllType<Bulletin>> =>
    axiosInstance.get(`/personnel/personnel/bulletins${complement ? `?${complement}` : ''}`, silent ? { silent: true } as any : undefined)
      .then(response => response.data)
}
